import LxcError from "~/core/models/LxcError.class";
import sectorsService from "~/modules/sector/services/sectors.service";

export function useDeleteSector(organizationCode?: number) {
  const isLoading: Ref<boolean> = ref(false);
  const error: Ref<LxcError | undefined> = ref();

  async function deleteSector(sectorCode: number): Promise<void> {
    isLoading.value = true;
    error.value = undefined;

    if (organizationCode) {
      const response = await sectorsService.removeSector(
        organizationCode,
        sectorCode,
      );
      if (LxcError.check(response)) {
        error.value = response;
      }
    } else {
      throw new Error("Organization code is undefined");
    }
    isLoading.value = false;
  }

  return {
    deleteSector,
    isLoading,
    error,
  };
}
